<template>
  <div :class="[
    'banner',
    `banner-${variant}`
  ]">
    <m-icon
      v-if="hasIcon"
      size="small"
      :variant="iconVariant"
    />
    <slot>
      <div class="banner-text">
        <div>{{ text }}</div>
      </div>
      <div class="banner-link">
        <a
          :href="linkHref ? linkHref : null"
          :target="openLinkNewTab ? '_blank' : null"
        >
          {{ linkText }}
        </a>
      </div>
    </slot>
  </div>
</template>

<script>
import MIcon from '../Icon';

export default {
  name: 'MBanner',
  components: {
    MIcon,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    hasIcon: {
      type: Boolean,
      default: true,
    },
    variant: {
      type: String,
      default: 'warning',
    },
    iconVariant: {
      type: String,
      default: 'info-fill',
    },
    linkText: {
      type: String,
      default: '',
    },
    linkHref: {
      type: String,
      default: '',
    },
    openLinkNewTab: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
